import { render, staticRenderFns } from "./OverviewOrders.vue?vue&type=template&id=99a19f20&"
import script from "./OverviewOrders.vue?vue&type=script&lang=js&"
export * from "./OverviewOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports